import styled from '@emotion/styled';
import { BoxProps, TextLink } from '@updater/ui-uds';
import { ArrowSquareOut } from '@phosphor-icons/react';
import {
  GridCardColumnBottom,
  GridCardColumnTop,
} from '../logo-grid-card/LogoGridCard.styles';

export const GridCardColumnRight = styled(GridCardColumnBottom)`
  display: block;
  max-width: 100%;
  justify-content: center;

  & > div {
    margin-top: 0;
  }
`;

export const GridCardColumnLeft = styled(GridCardColumnTop)<BoxProps>`
  width: 148px;
  padding: ${(props) => props.theme.space.xxl}px
    ${(props) => props.theme.space.s}px;
`;

export const InnerGrid = styled.div`
  display: flex;
  flex-direction: row;
  height: 128px;
`;

export const BottomArrowSquareOut = styled(ArrowSquareOut)`
  vertical-align: text-bottom;
`;

export const CTATextLink = styled(TextLink)`
  padding: 12px 0;
`;
